import { LOGO_SRC } from "./RevoraCard";

export const Footer = () => (
  <footer className="bg-ink text-white" data-testid="footer">
    <div className="max-w-7xl mx-auto px-6 py-20">
      <div className="flex flex-col md:flex-row justify-between gap-12">
        <div className="max-w-sm">
          <span className="inline-block bg-white rounded-md px-3.5 py-2.5 mb-6">
            <img src={LOGO_SRC} alt="Revora Reviews" className="h-10 w-auto" />
          </span>
          <p className="font-display text-2xl font-bold">Tap. Review. Done.</p>
          <p className="text-white/50 text-sm mt-3 leading-relaxed">
            NFC tap-to-review cards, programmed for your business before they ship.
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-10 text-sm">
          <div>
            <p className="text-white/40 uppercase tracking-[0.2em] text-xs font-bold mb-4">Site</p>
            <ul className="space-y-2.5 text-white/70">
              <li><a href="/#how-it-works" className="hover:text-white transition-colors">How It Works</a></li>
              <li><a href="/#products" className="hover:text-white transition-colors">Products</a></li>
              <li><a href="/#businesses" className="hover:text-white transition-colors">For Businesses</a></li>
              <li><a href="/#faq" className="hover:text-white transition-colors">FAQ</a></li>
              <li><a href="/track" className="hover:text-white transition-colors">Track Order</a></li>
            </ul>
          </div>
          <div>
            <p className="text-white/40 uppercase tracking-[0.2em] text-xs font-bold mb-4">Legal</p>
            <ul className="space-y-2.5 text-white/70">
              <li><a href="/privacy" className="hover:text-white transition-colors">Privacy Policy</a></li>
              <li><a href="/terms" className="hover:text-white transition-colors">Terms of Service</a></li>
              <li><a href="/shipping" className="hover:text-white transition-colors">Shipping Policy</a></li>
              <li><a href="/returns" className="hover:text-white transition-colors">Returns / Replacements</a></li>
            </ul>
          </div>
          <div>
            <p className="text-white/40 uppercase tracking-[0.2em] text-xs font-bold mb-4">Contact</p>
            <ul className="space-y-2.5 text-white/70">
              <li>Revora</li>
              <li>1214 Gruner Pl, Saint Louis, MO 63133</li>
              <li><a href="mailto:revorareviewsupport@gmail.com" className="hover:text-white transition-colors">revorareviewsupport@gmail.com</a></li>
              <li>Support: 6 a.m. – 9 p.m. Central</li>
              <li>RevoraReviews.com</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 mt-16 pt-8 flex flex-col sm:flex-row justify-between gap-4 text-xs text-white/40">
        <span>© {new Date().getFullYear()} Revora Reviews. All rights reserved.</span>
        <span>Google is a trademark of Google LLC. Revora is not affiliated with Google.</span>
      </div>
    </div>
  </footer>
);
